// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-webcontent-parent {
  overflow-y: auto;
}
.app-webcontent-parent ion-content::part(scroll) {
  overflow-y: hidden;
}

.spin-now-button {
  margin-bottom: 20px;
}

.result-pop-header {
  --box-shadow: unset;
  border: unset;
  background-color: #251850;
  color: #fdfe00;
}

.right {
  float: right;
}

.result-icon {
  color: #fdfe00;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-daily-spin-result/popover-daily-spin-result.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAAE;EACE,kBAAA;AAEJ;;AACA;EACE,mBAAA;AAEF;;AAAA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;AAGF;;AADA;EACE,YAAA;AAIF;;AAFA;EACE,cAAA;AAKF","sourcesContent":[".app-webcontent-parent {\n  overflow-y: auto;\n  ion-content::part(scroll) {\n    overflow-y: hidden;\n  }\n}\n.spin-now-button{\n  margin-bottom: 20px;\n}\n.result-pop-header {\n  --box-shadow: unset;\n  border: unset;\n  background-color: #251850;\n  color: #fdfe00;\n}\n.right{\n  float: right;\n}\n.result-icon{\n  color: #fdfe00;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
